export class SelfTestPelletizingCal {
  constructor({
        id= null, 
        selfTestCode = ``,
        sampleTime='',
        analysisTime = ``,
        compression=``,
        barrateIndex=``,
        antiwearIndex='',
        pelSize=``,
        checkUser=``,
        status=``,
    } = {}) {
    this.id = id;
    this.selfTestCode = selfTestCode;
    this.sampleTime=sampleTime;
    this.analysisTime = analysisTime;
    this.compression = compression;
    this.barrateIndex = barrateIndex;
    this.antiwearIndex=antiwearIndex;
    this.pelSize=pelSize;
    this.checkUser=checkUser;
    this.status=status;
  }
}
export function gridFields() {
  return Object.freeze(
      [
  
      
      {
        key: 'selfTestCode',
        label: 'lbl.selfTestPelletizingCal.shiftPlanNum',
        sortable: true,
        form: {
          type: 'input'
        }
      },          
      {
        key: 'analysisTime',
        label: 'lbl.selfTestPelletizingCal.analysisTime',
        sortable: true,
        form: {
          type: 'dateTime'
        }
      },
      // {
      //   key: 'sampleTime',
      //   label: 'lbl.selfTestPelletizingCal.sampleTime',
      //   sortable: true,
      //   form: {
      //     type: 'input'
      //   }
      // },   
      {
        key: 'compression',
        label: 'lbl.selfTestPelletizingCal.compression',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'barrateIndex',
        label: 'lbl.selfTestPelletizingCal.barrateIndex',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'antiwearIndex',
        label: 'lbl.selfTestPelletizingCal.antiwearIndex',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'pelSize',
        label: 'lbl.selfTestPelletizingCal.pelSize',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'checkUser',
        label: 'lbl.selfTestPelletizingCal.checkUser',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'status',
        label: 'lbl.selfTestPelletizingCal.status',
        sortable: true,
        form: {
          type: 'select',
          options: [                
              { value: 'N', text:  '未检验' },
              { value: 'C', text:  '已检验' },                          
            ]            
        }
      }
  ]);
}
export const fields = Object.freeze(Object.keys(new SelfTestPelletizingCal()).map(i => 'entity.' + i));
export const filterFields = [
  'filter.selfTestCodeFilter',
  'filter.analysisTimeDateFilter',
  'filter.checkUser'
];
export const filter = {
  'selfTestCodeFilter': "",
  'analysisTimeDateFilter': "",
  'checkUser':"",
};